import React, { useContext, useCallback, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { dynamoProductQueries } from '../../../../graphql/queries';
import HandDetails from './HandDetails.js';
import NotFoundMessage from '../../../../Components/Store/NotFoundMessage.js';
import LoadingScreen from '../../../../Components/LoadingScreen.js';
import {
  isFinalSetInCollection,
  isFinalHandInSet,
  getNextSetInCollection
} from '../../../../helpers/product.js';
import {
  getNextHand,
  formatPathToHandPlay
} from '../../../../helpers/hand.js';
import {
  HandContext,
  UserContext
} from '../../../../Context';
import { useHandAndParentQuery } from '../../../../Hooks';

export default function CollectionHandDetails () {
  let {
    collectionId,
    setId,
    handId,
    language
  } = useParams();

  handId = parseInt(handId);
  collectionId = parseInt(collectionId);
  setId = parseInt(setId);

  const navigate = useNavigate();

  const { user } = useContext(UserContext);

  const { init: initHandContext } = useContext(HandContext);

  const queryResponse = useHandAndParentQuery({
    handId,
    parentId: collectionId,
    language,
    parentQuery: dynamoProductQueries.DynamoProductById
  });

  // useHandAndParentQuery only knows the queries resolved, not that the ids matched —
  // the inner hand/collection (and the set within it) are null for a bad deep link, so
  // extract and guard them here.
  const collection = queryResponse && queryResponse.parentData && queryResponse.parentData.dynamoProductById;
  const hand = queryResponse && queryResponse.handData && queryResponse.handData.handById;
  const set = collection && collection.sets && collection.sets.find(set => set.id === setId);

  const getNextHandUrl = useCallback((collection, set) => {
    let nextSet = set;
    let nextHand;
    const isFinalHand = isFinalHandInSet(handId, set.hands);
    const isFinalSet = isFinalSetInCollection(set.id, collection.sets);
    if (isFinalHand && !isFinalSet) {
      // is this the final hand in set but NOT the final set in collection
      // ... get next set and get first hand in that set
      nextSet = getNextSetInCollection(set.id, collection.sets);
      nextHand = nextSet.hands[0];
    } else {
      // ... keep the same set but get next hand
      nextHand = getNextHand(handId, set.hands);
    }
    return formatPathToHandPlay(collection.id, nextSet, nextHand);
  }, [handId]);

  useEffect(() => {
    if (collection && set && hand) {
      initHandContext({
        hand,
        parent: set,
        grandParent: collection,
        nextHandUrl: getNextHandUrl(collection, set),
        currentUser: user
      });
    }
  }, [collection, set, hand, initHandContext, getNextHandUrl, user]);

  if (!queryResponse) {
    return <LoadingScreen />;
  }

  if (!collection || !set || !hand) {
    return (
      <NotFoundMessage
        message='hand-not-found'
        actionLabel='browse-products'
        onAction={() => navigate('/products')}
      />
    );
  }

  return (
    <HandDetails />
  );
}
